export default "__VITE_ASSET__BvDd57iE__"